var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	90132: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(264), __webpack_require__.e(218), __webpack_require__.e(76), __webpack_require__.e(17)]).then(() => (() => (__webpack_require__(77017))))))),
	92786: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(610)]).then(() => (() => (__webpack_require__(7610))))))),
	55883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(141), __webpack_require__.e(340)]).then(() => (() => (__webpack_require__(31340))))))),
	76883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(141), __webpack_require__.e(620)]).then(() => (() => (__webpack_require__(23620))))))),
	77427: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-icon", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(781)]).then(() => (() => (__webpack_require__(82781))))))),
	21926: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(264), __webpack_require__.e(107), __webpack_require__.e(39)]).then(() => (() => (__webpack_require__(36039))))))),
	49107: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(774), __webpack_require__.e(276)]).then(() => (() => (__webpack_require__(7276))))))),
	333: () => (loadSingletonVersion("default", "tslib", false, [1,2,3,0], () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(24398))))))),
	93774: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(264), __webpack_require__.e(15)]).then(() => (() => (__webpack_require__(18015))))))),
	68783: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [4,4,24,0], () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(89676))))))),
	42364: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [4,4,0,20], () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(8653))))))),
	61689: () => (loadStrictSingletonVersion("default", "zone.js", false, [2,0,15,1], () => (__webpack_require__.e(743).then(() => (() => (__webpack_require__(74124))))))),
	90815: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-inline-alert", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(439), __webpack_require__.e(529), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(1964))))))),
	99699: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-circle-loading", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(479), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(89201))))))),
	10096: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,20,3,18], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(52867))))))),
	91990: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,20,3,18], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(85689))))))),
	55651: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-helpers", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(90389))))))),
	2468: () => (loadSingletonVersion("default", "@bancolombia/design-system-behaviors", false, [1,8,33,7], () => (__webpack_require__.e(747).then(() => (() => (__webpack_require__(53747))))))),
	37811: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-tooltip", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(44183))))))),
	94529: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-icon-button", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(427), __webpack_require__.e(124), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(1622))))))),
	12083: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-avatar", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(811), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(36581))))))),
	479: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-loader", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(38663))))))),
	1389: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-preloader", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(26468))))))),
	94859: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-logo", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(92731))))))),
	28439: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-link", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(76662))))))),
	8753: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-accordion", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(811), __webpack_require__.e(529), __webpack_require__.e(160)]).then(() => (() => (__webpack_require__(46160))))))),
	94759: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-stroke", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(25818))))))),
	82099: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-badge", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(95751))))))),
	98835: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-float-menu", false, [1,14,28,1], () => (__webpack_require__.e(64).then(() => (() => (__webpack_require__(16064))))))),
	67124: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,20,3,18], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(264), __webpack_require__.e(456)]).then(() => (() => (__webpack_require__(34456))))))),
	57707: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-services", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(264), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(44182))))))),
	92891: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-transaction-status", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(427), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(91253))))))),
	58571: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-button", false, [1,14,28,1], () => (__webpack_require__.e(76).then(() => (() => (__webpack_require__(22482))))))),
	37999: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-footer", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(859), __webpack_require__.e(439), __webpack_require__.e(343)]).then(() => (() => (__webpack_require__(3343))))))),
	48427: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-menu", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(779)]).then(() => (() => (__webpack_require__(34779))))))),
	75987: () => (loadSingletonVersion("default", "@bancolombia/design-system-web/bc-header", false, [1,14,28,1], () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(468), __webpack_require__.e(811), __webpack_require__.e(859), __webpack_require__.e(185)]).then(() => (() => (__webpack_require__(4185)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"17": [
		10096,
		91990
	],
	"64": [
		1389
	],
	"83": [
		12083
	],
	"107": [
		49107
	],
	"124": [
		67124
	],
	"132": [
		90132
	],
	"185": [
		82099,
		98835
	],
	"264": [
		76883
	],
	"333": [
		333
	],
	"343": [
		8753,
		94759
	],
	"384": [
		37999,
		48427,
		75987
	],
	"427": [
		77427
	],
	"439": [
		28439
	],
	"468": [
		2468
	],
	"479": [
		479
	],
	"529": [
		94529
	],
	"651": [
		55651
	],
	"774": [
		93774
	],
	"783": [
		68783
	],
	"786": [
		92786
	],
	"803": [
		58571
	],
	"811": [
		37811
	],
	"826": [
		42364,
		61689,
		90815,
		99699
	],
	"859": [
		94859
	],
	"883": [
		55883
	],
	"926": [
		21926
	],
	"964": [
		57707,
		92891
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}